<template>
  <div class="col-md-4 col-xs-12">
    <div class="bg-blue-grey-100 admin-package-box p-30 font-size-14 admin-package-box clearfix" v-if="showPayPlanForm">
      <form v-on:submit.prevent="onSubmitPayplan" v-if="!team.has_reseller && !team.is_reseller">
        <div class="row">
          <div class="col-md-12">
            <alert v-show="showPayPlanAlert"
              alertClass="m-b-25 alert-dismissible"
              v-bind:type="`${ (successPayPlanResponse) ? 'success' : 'danger' }`"
              v-bind:iconClass="`${ (successPayPlanResponse) ? 'md-check' : 'md-close' }`">
              <span v-if="successPayPlanResponse">{{successPayPlanResponse}}</span>
              <span v-else-if="errorPayPlanResponse">{{errorPayPlanResponse}}</span>
            </alert>
            <label for="role" class="form-control-label">Pay Plan</label>
            <form-group v-bind:error="formErrors.first('payPlan')">
              <div class="radio-custom radio-primary">
                <input type="radio" id="prepaid" value="prepaid" v-model="team.pay_plan">
                <label for="payplan">Pre paid</label>
              </div>
              <div class="radio-custom radio-primary">
                <input type="radio" id="postpaid" value="postpaid" v-model="team.pay_plan">
                <label for="payplan">Post paid</label>
              </div>
            </form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button type="submit" class="btn btn-success pull-xs-left">
              Update Plan
            </button>
          </div>
          <div class="col-md-6">
            <button type="button" class="btn btn-link pull-xs-right" v-on:click="cancelPayPlanForm">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="bg-blue-grey-100 admin-package-box p-30 font-size-14" v-else>
      <div class="counter counter-md text-xs-left">
        <div class="counter-label text-uppercase m-b-5">Customer Type Setting</div>
        <span class="counter-number text-capitalize"> {{team.pay_plan}} </span>
        <div class="counter-label m-b-5 m-t-20">Suspension policy : Auto </div>
        <!--div class="counter-label m-b-5">Last added: 1 Mar 2017 20:05</div-->
        <div class="counter-label text-uppercase m-b-5 m-t-20">
          <button
            type="button"
            class="btn btn-primary"
            v-if="!team.has_reseller"
            v-on:click="togglePayPlanForm">Change plan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';

export default {
  components: {
    Alert,
    FormGroup,
  },
  props: {
    team: {
      type: Object,
    },
  },
  computed: {
    currentSupsend: function () {
      if (this.team && this.team.suspend) {
        if (this.team.suspend.is_manual_locked) {
          if (this.team.suspend.is_suspend) {
            return 'Suspend';
          } else {
            return 'Active';
          }
        } else {
          return 'Auto';
        }
      }
    },
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);

    this.validator = new Validator();
    this.validator.attach('payPlan', 'required', { prettyName: 'pricing plan' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  data: function() {
    return {
      showPayPlanAlert: false,
      errorPayPlanResponse: null,
      successPayPlanResponse: null,
      validator: null,
      formErrors: null,
      showPayPlanForm: false,
    };
  },
  methods: {
    onSubmitPayplan: function () {
      this.showPayPlanAlert = false;

      axios.post(`api/admin/setpayplan`, {
        namespace: this.team.namespace,
        pay_plan: this.team.pay_plan,
      })
      .then((response) => {
        this.successPayPlanResponse = this.$t('team.response.success');
        this.cancelPayPlanForm();
        this.team.pay_plan = response.data.pay_plan;
        this.errorPayPlanResponse = null;
      })
      .catch((error) => {
        // TODO: show error message from api
        if (error.response.status === 422) {
          this.errorPayPlanResponse = this.$t('team.response.failed');
        } else {
          this.errorPayPlanResponse = this.$t('team.response.defaultFailed');
        }
        this.showPayPlanAlert = true;
      });
    },
    togglePayPlanForm: function () {
      this.showPayPlanForm = true;
    },
    cancelPayPlanForm: function () {
      this.showPayPlanForm = false;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PayPlan.vue?65865f16